import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { IFormSelectInputOption } from '@modules/forms/types';
import { AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_PERMISSIONS } from '@modules/affiliate-program-subaffiliate-deals/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IAffiliateProgramSubAffiliateDealsConditionsListResponse,
} from '../types';
import {
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_CONSTANTS_LIST_QUERY_KEY,
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_CONSTANTS_LIST_URL,
} from '../constants';

export default function useAffiliateProgramSubAffiliateDealsConstantsListQuery(): IContextQueryResult<
  IAffiliateProgramSubAffiliateDealsConditionsListResponse,
  Error,
  IFormSelectInputOption<string>[]
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<
    IAffiliateProgramSubAffiliateDealsConditionsListResponse,
    Error,
    IFormSelectInputOption<string>[]
  >({
    queryKey: [AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_CONSTANTS_LIST_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IAffiliateProgramSubAffiliateDealsConditionsListResponse>(
      AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_CONSTANTS_LIST_URL,
      {
        signal,
        permission: AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_PERMISSIONS.EDIT,
      },
    ),
    select: (data) => (
      Object.entries(data.constants.subaffiliate_condition_steps.payment_column).map(([label, value]) => ({
        value,
        label,
      }))
    ),
  });
}
